import { auth } from "../../firebase";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
} from "firebase/auth";

export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const SIGNUP_REQUEST = "SIGNUP_REQUEST";

export const SIGNUP = "SIGNUP";
export const LOGIN = "LOGIN";

export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const SIGNUP_FAILURE = "SIGNUP_FAILURE";

export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const LOGOUT = "LOGOUT";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";

export const signup = (email, password) => {
  return async (dispatch) => {
    let user;
    let token;
    try {
      dispatch({
        type: SIGNUP_REQUEST,
      });
      const userCredentials = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      user = userCredentials?.user;
      token = await user.getIdToken();
      localStorage.setItem("token", token);
      localStorage.setItem("email", user?.email);
      localStorage.setItem("userId", user?.uid);
      if (token) {
        dispatch({
          type: SIGNUP,
          token,
          userId: user?.uid,
          email: user?.email,
        });
      }
    } catch (error) {
      console.log(error.message);
      dispatch({
        type: SIGNUP_FAILURE,
        errorRes: error.message,
      });
    }
  };
};

export const login = (email, password) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: LOGIN_REQUEST,
      });
      const userCredentials = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      let user;
      let token;
      user = userCredentials?.user;
      token = await user.getIdToken();
      localStorage.setItem("token", token);
      localStorage.setItem("email", user?.email);
      localStorage.setItem("userId", user?.uid);
      if (token) {
        dispatch({
          type: LOGIN,
          token,
          userId: user?.uid,
          email: user?.email,
        });
      }
    } catch (error) {
      console.log(error);
      dispatch({
        type: LOGIN_FAILURE,
        errorRes: error.message,
      });
    }
  };
};

export const isUserLoggedIn = () => {
  return async (dispatch) => {
    const token = localStorage.getItem("token");
    const email = localStorage.getItem("email");
    const userId = localStorage.getItem("userId");
    if (token) {
      dispatch({
        type: LOGIN,
        token,
        userId,
        email,
      });
    } else {
      dispatch({
        type: LOGIN_FAILURE,
        errorRes: "Failed to login",
      });
    }
  };
};

export const signout = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: LOGOUT_REQUEST });
      await auth.signOut();
      dispatch({ type: LOGOUT });
    } catch (error) {
      dispatch({ type: LOGOUT_FAILURE, errorRes: error.message });
    }
  };
};
